<template>
	<div class="admin-profile">
		<div class="vx-row">
			<div class="vx-col w-full xl:w-3/4 mb-5">
				<vx-card>
					<h1>{{ $t('profile') }}</h1>
					<div class="info mt-5 flex-col sm:flex-row">
						<div class="photo">
							<img :src="$store.state.auth.user.photo" alt="">
						</div>
						<div class="data mt-10 sm:mt-5">
							<div class="tables">
								<table>
									<tbody>
										<tr>
											<td>{{ $t('personName') }}</td>
											<td>{{$store.state.auth.user.first_name }} {{$store.state.auth.user.last_name }}</td>
										</tr>
										<tr>
											<td>Email</td>
											<td>{{$store.state.auth.user.email }}</td>
										</tr>
									</tbody>
								</table>
							</div>
						</div>
					</div>
					<vs-button
						@click="$router.push('/profile/edit')"
						class="mt-10 edit-btn"
					>{{ $t('edit') }}</vs-button>
				</vx-card>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: "Admin",
	data() {
		return {
			popupActive: false,
			val: '',
			description: '',
			countries: [],
			genders: [],
			languages: [],
			subjects: []
		}
	},
	async mounted() {
		try {
			this.languages = (await this.$http.get('/settings/get-languages')).data.data;
			this.subjects =  (await this.$http.get('/settings/get-subjects')).data.data;
			this.countries = (await this.$http.get('/settings/get-countries')).data.data
			this.genders = (await this.$http.get('/settings/get-genders')).data.data
			let res = await this.$http('/'+this.$store.state.auth.role+'/profile')
		} catch (e) {

		}
	},
	methods: {
		acceptChangeManager() {

		}
	}
}
</script>

<style lang="scss">
@import "../../assets/scss/vuexy/variables";
@import "../../assets/scss/vuexy/functions";

.admin-profile {
	.data{
		width: 100%;
	}
	.feature {
		span {
			color: $success;
		}

		.vx-card__body {
			display: flex;
			justify-content: space-between;
			align-items: center;
		}

		strong {
			font-size: rem(18px);

			b {
				color: $danger;
			}
		}
	}

	h1 {
		font-size: 18px;
		color: #626262;
		margin-bottom: 15px;
		font-weight: 700;
	}

	.vx-card {
		height: 100%;
		padding-right: 0;
	}


	table {
		margin-bottom: 20px;
		padding-left: 15px;
		width: 100%;
		max-width: 500px;

		tr {

			td {
				padding-bottom: 7px;

				&:first-child {
					max-width: 250px;
					//width: auto !important;
					width: 40%;
					font-weight: 600;
				}
			}

		}
	}

	.info {
		display: flex;

		.tables {
			display: flex;
			justify-content: space-between;
			&>table{
				&:first-child{
					margin-right: 50px;
					flex-shrink: 0;
				}
			}
		}

		.about {
			display: flex;
			margin-left: 20px;

			b {
				flex-shrink: 0;
				//width: 250px;
			}
		}
	}

	.photo {
		width: 200px;
		height: 200px;
		border-radius: 10px;
		overflow: hidden;
		margin: 15px 15px;
		margin-left: 0;
		flex-shrink: 0;
		margin-right: 35px;


		img {
			max-width: 100%;
			width: 100%;
			height: 100%;
		}
	}

	.box {
		display: flex;
		font-size: 25px;
		align-items: center;
		margin-bottom: 22px;
	}

	.bottom {
		display: flex;
		justify-content: flex-end;
	}

	.edit-btn {
		width: 100%;
		max-width: 200px;
	}
}
</style>
